<template>
  <div class="home">
    <div class="section section-1">
      <div class="section-1_left">
        <h1>EVERYDAY<br />PLACES</h1>
        <img
          class="tube-map"
          alt="tube map graphic"
          src="../assets/blue-lines.png"
        />
      </div>
      <div class="section-1_right">
        <h2 class="subtitle">
          Improving shops is Britain’s most important regeneration priority.
        </h2>
        <p>
          We asked people to think about what was available in their local area
          at the moment and tell us what needed improving most urgently. The
          most popular answer for the country as a whole was “good local shops”
          followed by “good transport services”.
        </p>
        <router-link to="/most-urgent" onclick="window.fathom.trackGoal('8SKKFQ4U', 0);"
          ><p class="explore-link s1 mr yellow-bg">
            EXPLORE BY LOCATION
          </p>
        </router-link>
      </div>
    </div>
    <div class="section section-2">
      <div class="section-2_content">
        <h2 class="subtitle">
          A new way of measuring ‘place’.
        </h2>
        <p>
          We asked people to rate how well their local areas were doing on the
          everyday things they themselves thought were important. Overall,
          around three-quarters of the population thought the local availability
          of the items they needed and wanted was nearer ‘good’ than ‘bad'.
        </p>
        <br />
        <p>
          We asked about access to fresh air and nature, shops, transport,
          housing, internet access, places to go out, premises to support jobs,
          exercise and sports facilities and supportive communities and pleasant
          streets.
        </p>
        <div class="section-1_left">
          <img
            class="tube-map"
            alt="tube map graphic"
            src="../assets/blue-lines.png"
          />
        </div>
      </div>
    </div>
    <div class="section section-3">
      <div class="section-3_content">
        <h2 class="subtitle">READ THE REPORTS</h2>
        <p>
          Working with Legal &amp; General, Demos has produced two reports.<br/><br/>
          <a class="white" href="https://demos.co.uk/wp-content/uploads/2021/04/Everyday-Places.pdf"><strong>Everyday Places</strong></a> outlines our findings in detail, including a close look at 
          our methodology and policy recommendations.<br/><br/>
          <a class="white" href="https://demos.co.uk/wp-content/uploads/2021/03/Post-Pandemic-Places-Report.pdf"><strong>Post Pandemic Places</strong></a> takes a detailed look at the impact of Covid-19 on local 
          areas around the UK. 
        </p>
        <p class="italic">
          "Covid-19 has driven major change to people’s lives and global
          economies. Our ideas around what we need from our homes, workplace and
          communities have been challenged."
        </p>
        <p class="quote-author">
          <strong>— Nigel Wilson, <i>Chief Executive of Legal &amp; General Group</i></strong>
        </p>
        <div id="buttons">
          <a href="https://demos.co.uk/wp-content/uploads/2021/03/Post-Pandemic-Places-Report.pdf" onclick="window.fathom.trackGoal('6QLP2EMC', 0);">
            <p class="explore-link mr s3 yellow-bg">READ POST PANDEMIC PLACES</p>
          </a>
          <a href="https://demos.co.uk/wp-content/uploads/2021/04/Everyday-Places.pdf">
            <p class="explore-link mr s3 blue-bg" onclick="window.fathom.trackGoal('8WTJSBRA', 0);">READ EVERYDAY PLACES</p>
          </a>
        </div>
        <a href="https://demos.co.uk/wp-content/uploads/2021/03/Post-Pandemic-Places-Report.pdf">  
          <img
            id="ppp" class="report-cover"
            alt="The cover of Post Pandemic Places"
            src="../assets/ppp-cover.png"
          />
        </a>
        <a href="https://demos.co.uk/wp-content/uploads/2021/04/Everyday-Places.pdf">
          <img
            id="ep" class="report-cover"
            alt="The cover of Everyday Places"
            src="../assets/everyday-places-cover.png"
          />
        </a>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: "Home"
};
</script>

<style scoped>

  .home {
    display: flex;
    flex-direction: column;
  }

  #buttons {
    display: flex;
    flex-direction: row;
  }

  #buttons p {
    margin-left: 20px;
  }

  .section {
    min-height: 500px;
    overflow: hidden;
  }

  .subtitle {
    text-transform: uppercase;
  }

  h1 {
    font-size: 3em;
    font-family: "Avenir Black", Avenir, Helvetica, Arial, sans-serif;
    line-height: 1.1em;
  }

  .underline {
    font-family: "Avenir Black";
    text-decoration-line: underline;
    text-decoration-color: #1d3336;
    text-decoration-thickness: 3px;
  }

  .section-1 {
    flex: 1;
    display: flex;
    justify-content: space-between;
    padding: 1rem 2rem;
    background-color: #ee7155;
    position: relative;
  }


  .section-1_left {
    display: flex;
    flex-direction: column;
    width: 30vw;
    min-width: max-content;
    margin-right: 5rem;
  }

  .section-1_right {
    display: flex;
    flex-direction: column;
    justify-content: center;
    text-align: right;
    max-width: 600px;
  }

  .section-1_right > * {
    margin-top: 2rem;
  }

  .tube-map {
    position: absolute;
    width: 89%;
    min-width: 1000px;
  }

  .section-1 .tube-map {
    transform: rotate(25deg);
    top: 265px;
    right: 30%;
  }

  .section-2 .tube-map {
    top: 2%;
    left: 68%;
    transform: scaleX(-1);
  }

  #ppp {
    left: 56px;
    top: 106px;
    position: absolute;
    transform: rotate(-9deg);
    width: 210px;
  }

  #ep {
    left: 197px;
    top: 181px;
    position: absolute;
    transform: rotate(13deg);
    width: 210px;
  }

  .italic {
    font-style: italic;
  }

  .section-2 {
    border-bottom: 1px solid #1d3336;
    flex: 1;
    padding: 1rem 2rem;
    display: flex;
    flex-direction: column;
    justify-content: center;
    background-color: #e0f1f8;
    position: relative;
  }

  .section-2_content {
    max-width: 500px;
  }

  .section-2_content > * {
    margin-top: 2rem;
  }

  .section-3_content {
    max-width: 100%;
    padding: 0 0 2.5rem 2.5rem;
  }

  .section-3_content > * {
    margin-top: 2rem;
  }

  .section-3 {
    flex: 1;
    padding: 1rem 2rem;
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: flex-end;
    text-align: end;
    background-color: #1d3336;
    color: whitesmoke;
    position: relative;
  }

  .quote-author {
    font-size: 1em;
    margin-top: 1rem;
  }

  .explore-link {
    font-weight: bold;
    cursor: pointer;
    margin-top: 2rem;
    width: max-content;
    width: -moz-max-content; 
    width: -webkit-max-content; 
    padding: 8px;
  }

   .section-1_right > a {
    width: fit-content;
    width: -moz-fit-content; 
    width: -webkit-fit-content; 
    display: contents;
  }

  .yellow-bg {
    background-color: #feebb3;
    color: #1d3336;
  }

  .blue-bg {
    background-color: #85ccd1;
    color: #1d3336;
  }

  a {
    text-decoration: none;
  }

  .white {
    color: white;
  }

  .s1 {
    text-align: end;
  }
  .s1,
  .s2 {
    color: #1d3336;
  }

  .mr {
    margin-left: auto;
  }

  .demos-o {
    color: white;
    font-weight: 200;
    font-family: "Avenir", sans-serif;
  }

  /* Stop tube maps in their tracks on low widths */
  @media screen and (max-width: 960px) {
    .section-1 .tube-map {
      right: 283px;
    }

    .section-2 .tube-map {
      left: 643px;
    }
  }

  /* Prevent report covers from clipping */
  @media screen and (max-width: 1030px) {
    .report-cover {
      display: none;
    }
  }

  @media screen and (max-width: 600px) {
    .section-1 {
      flex-direction: column;
    }
  }

  /* Collapse header size at small screen sizes */
  @media screen and (max-width: 320px) {
    h1 {
      font-size: 2em;
    }

    .section-1_left {
      margin-bottom: 30px;
    }
  }

  @media screen and (max-width: 663px){ 
    #buttons {
      flex-direction: column;
      align-items: center;
    }
  }

  @media screen and (min-width: 990px){ 
    .section-3_content {
      max-width: 550px;
    }
  }

</style>
